import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

interface SharedTabHeaderProps {
  title: string;
  children?: ReactNode;
  noDivider?: boolean;
}

export default function SharedTabHeader({
  title,
  children,
  noDivider = false,
}: SharedTabHeaderProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        borderBottom: noDivider ? 0 : 0.5,
        borderColor: theme.palette.semantic.outline.light,
        p: 1,
        mb: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: theme.palette.semantic.text.title2,
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box>{children}</Box>
    </Box>
  );
}
